import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function CheckboxTick(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 10"
  }, props), React.createElement("path", {
    d: "M13.527.466a.75.75 0 01.007 1.06l-7.886 8a.75.75 0 01-1.068 0L.466 5.354A.75.75 0 111.534 4.3l3.58 3.632L12.466.473a.75.75 0 011.06-.007z"
  }));
}

export { CheckboxTick };
//# sourceMappingURL=CheckboxTick.js.map